export const safeMap = (array, callback) => {
  return array && array.length > 0 && array.map(callback);
};
